/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S7_PrefixInputs */

const tr_cerez_s7_prefix = /** @type {(inputs: Cerez_S7_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla bilgi için`)
};

const en_cerez_s7_prefix = /** @type {(inputs: Cerez_S7_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For more information, please see our`)
};

const de_cerez_s7_prefix = /** @type {(inputs: Cerez_S7_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Informationen können Sie unseren Seiten`)
};

const ru_cerez_s7_prefix = /** @type {(inputs: Cerez_S7_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительную информацию можно найти на страницах`)
};

/**
* | output |
* | --- |
* | "For more information, please see our" |
*
* @param {Cerez_S7_PrefixInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s7_prefix = /** @type {((inputs?: Cerez_S7_PrefixInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S7_PrefixInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s7_prefix(inputs)
	if (locale === "de") return de_cerez_s7_prefix(inputs)
	if (locale === "ru") return ru_cerez_s7_prefix(inputs)
	return tr_cerez_s7_prefix(inputs)
});